import React from "react";
import styled from "styled-components";
import { renderToStaticMarkup } from "react-dom/server";
import { Theme } from "../theme";
import { UspsFormControlStyles } from "./UspsFormControl";
import { DownCarrat } from "./icons";

export const Select = styled.select`
    ${UspsFormControlStyles}
    appearance: none;
    color: ${Theme.colors.blue};
    background-image: url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(
        renderToStaticMarkup(<DownCarrat />)
    )}");
    background-position: top 18px right 10px;
    background-repeat: no-repeat;
`;

Select.displayName = "Select";
